import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ReactTable from 'react-table';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';
import { columnsShort } from '../AdminUserTransactionList/tableColumns';
import { useQuery } from 'react-apollo';
import { GetUserTransactionsQuery } from '../../../operations/queries/GetUserTransactionsQuery';
import { handleRequestError } from '../../../constants/errorCodes';
import { ROUTE_TO_ADMIN_TRANSACTIONS_PAGE } from '../../../constants/routes';
import { CustomButton } from '../../../containers';

export const UserTransactionsTable = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const DEFAULT_PAGE_SIZE = 11;
  const take = 15;

  const startOfDay = moment()
    .startOf('day')
    .toISOString();

  const { data, loading, fetchMore } = useQuery(GetUserTransactionsQuery, {
    variables: {
      filter: { createdAtMoreThanOrEqual: startOfDay },
      skip: 0,
      take: DEFAULT_PAGE_SIZE,
      order: { createdAt: 'DESC' },
    },
    onError: error => handleRequestError(error, dispatch),
  });

  const payments = get(data, 'getPayments.payments', []);
  const queryCount = get(data, 'getPayments.queryCount', 0);

  const onLoadMore = () => {
    if (payments.length < queryCount) {
      fetchMore({
        variables: {
          filter: { createdAtMoreThanOrEqual: startOfDay },
          order: { createdAt: 'DESC' },
          skip: payments.length,
          take,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;
          return Object.assign({}, prev, {
            getPayments: {
              ...fetchMoreResult.getPayments,
              payments: [...prev.getPayments.payments, ...fetchMoreResult.getPayments.payments],
            },
          });
        },
      });
    }
  };

  const handleScroll = ({ currentTarget }) => {
    if (currentTarget.scrollTop + currentTarget.clientHeight >= currentTarget.scrollHeight) {
      onLoadMore();
    }
  };

  return (
    <ReactTable
      className="hok-admin-home-table transactions-table mb-5 mb-md-0 -striped -highlight"
      style={{ height: '526px' }}
      TheadComponent={() => <TransactionsTableHeader />}
      sortable={false}
      data={payments}
      columns={columnsShort}
      minRows={payments.length >= DEFAULT_PAGE_SIZE ? DEFAULT_PAGE_SIZE : 10}
      loading={loading}
      manual
      getTbodyProps={() => ({
        onScroll: handleScroll,
      })}
      getTrProps={(_, rowInfo) => ({
        onClick: () => {
          history.push(`${ROUTE_TO_ADMIN_TRANSACTIONS_PAGE}/${rowInfo.original.confirmationCode}`);
        },
      })}
      PaginationComponent={() => null}
      loadingText={<FormattedMessage id="adminUsersListPage.tableLoading" />}
      noDataText={<FormattedMessage id="adminUsersListPage.tableNoData" />}
    />
  );
};

const TransactionsTableHeader = () => {
  const history = useHistory();

  return (
    <div className="rt-thead -header" style={{ minWidth: '710px' }}>
      <div className="rt-tr transactions-table-title" role="row">
        <div className="rt-th react-table-headers">
          <h3 className="mb-0">Dnevne transakcije korisnika</h3>
          <CustomButton
            outline
            color="primary"
            className="hok-outline-btn ml-4 ml-md-0"
            translationId="showAll"
            onClick={() => history.push(ROUTE_TO_ADMIN_TRANSACTIONS_PAGE)}
          />
        </div>
      </div>
      <div className="rt-tr" role="row">
        <div
          className="rt-th react-table-headers rt-resizable-header"
          role="columnheader"
          tabIndex="-1"
          style={{ flex: '120 0 auto', width: '120px' }}>
          <div className="rt-resizable-header-content">
            <FormattedMessage id="adminUserTransactionsPage.columns.orderId" />
          </div>
          <div className="rt-resizer"></div>
        </div>
        <div
          className="rt-th react-table-headers rt-resizable-header"
          role="columnheader"
          tabIndex="-1"
          style={{ fontWeight: 500, flex: '250 0 auto', width: '250px', maxWidth: '250px' }}>
          <div className="rt-resizable-header-content">
            <FormattedMessage id="adminUserTransactionsPage.columns.creationTimestamp" />
          </div>
          <div className="rt-resizer"></div>
        </div>
        <div
          className="rt-th react-table-headers rt-resizable-header"
          role="columnheader"
          tabIndex="-1"
          style={{ flex: '100 0 auto', width: '100px' }}>
          <div className="rt-resizable-header-content">
            <FormattedMessage id="adminUserTransactionsPage.columns.orderType" />
          </div>
          <div className="rt-resizer"></div>
        </div>
        <div
          className="rt-th react-table-headers rt-resizable-header"
          role="columnheader"
          tabIndex="-1"
          style={{ flex: '120 0 auto', width: '120px' }}>
          <div className="rt-resizable-header-content">
            <FormattedMessage id="adminUserTransactionsPage.columns.orderValue" />
          </div>
          <div className="rt-resizer"></div>
        </div>
        <div
          className="rt-th react-table-headers rt-resizable-header"
          role="columnheader"
          tabIndex="-1"
          style={{ flex: '120 0 auto', width: '120px' }}>
          <div className="rt-resizable-header-content">
            <FormattedMessage id="adminUserTransactionsPage.columns.actionStatus" />
          </div>
          <div className="rt-resizer"></div>
        </div>
      </div>
    </div>
  );
};
